export default __webpack_public_path__ + "static/media/logo_white_red.f4ee1260.png";